import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import BlacklistCard from '@/components/feature/BlacklistCard';
import { getLatestBlacklist } from '@/utils/content';

export default function BlacklistHighlight() {
  const items = getLatestBlacklist(3);
  return (
    <section className="bg-background-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <SectionTitle
          icon="ri-alarm-warning-line"
          title="今日黑榜速览"
          subtitle="表现指数最低、排名下滑最明显的选手名单"
          action={
            <Link
              to="/category/blacklist"
              className="text-sm font-medium text-primary-700 hover:text-primary-800 flex items-center gap-1 cursor-pointer whitespace-nowrap"
            >
              全部黑榜
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((item) => (
            <BlacklistCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}